import { Factory } from 'fishery';
import { Contact } from '@trukt/types/Contact';
import { NonNullableKeys } from '@trukt/types/NonNullableKeys';
import { userFactory } from './userFactory';

export const contactFactory = Factory.define<Required<NonNullableKeys<Contact>>>(
  ({ sequence }) => ({
    guid: sequence.toString(),
    name: 'John Snow',
    phoneNumber: '555-555-5555',
    mobileNumber: '555-555-5556',
    email: 'johnsnow@gmail.com',
    title: 'lead',
    department: 'Parts Department',
    dateCreated: '2023-12-29',
    createdBy: userFactory.build(),
    updatedBy: userFactory.build(),
    dateUpdated: '2023-12-29',
    isActive: true,
    canLogin: true,
  }),
);
